var _rect, _rect2, _g, _circle, _path, _path2, _circle2, _circle3, _circle4, _path3, _path4, _circle5, _path5, _path6, _circle6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNobooking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 14,
    width: 3,
    height: 9,
    rx: 1.5,
    fill: "#2A928A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 14,
    width: 3,
    height: 9,
    rx: 1.5,
    fill: "#2A928A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1463 18.5H54.8537C55.3121 18.5 55.5 18.8219 55.5 19V55C55.5 55.1781 55.3121 55.5 54.8537 55.5H15.1463C14.6879 55.5 14.5 55.1781 14.5 55V19C14.5 18.8219 14.6879 18.5 15.1463 18.5Z",
    stroke: "#2A928A",
    strokeWidth: 3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 33,
    r: 4,
    fill: "#BAD1CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 30L21 37",
    stroke: "#CE4671",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30L27 37",
    stroke: "#CE4671",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 33,
    r: 4,
    fill: "#BAD1CF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 33,
    r: 4,
    fill: "#BAD1CF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 45,
    r: 4,
    fill: "#BAD1CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42L32 49",
    stroke: "#CE4671",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42L38 49",
    stroke: "#CE4671",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 45,
    r: 4,
    fill: "#BAD1CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42L43 49",
    stroke: "#CE4671",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42L49 49",
    stroke: "#CE4671",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 4,
    fill: "#BAD1CF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 9,
    y: 17,
    width: 52,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobooking);
export default __webpack_public_path__ + "static/media/nobooking.4b0198ae6e5fda6eeff1a06c12cc5f89.svg";
export { ForwardRef as ReactComponent };